import { useEffect, useState } from "react"
import { SearchBar } from "../../components/SearchBar"
import { MobileSubscription } from "../../interface/MobileSubscription"
import { BillingApi } from "../../api/BillingApi"
import { SubscriptionsList } from "./SubscriptionsList"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import Chip from "@mui/material/Chip"
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { alpha, useTheme } from "@mui/material/styles"
import { LottieLoading } from "../../components/placeholder/LottieLoading"
import { SubscriptionManageModalAndroid } from "./SubscriptionManageModalAndroid"
import { SubscriptionManageModalApple } from "./SubscriptionManageModalApple"




export const SubscriptionsContainer = () => {
    const theme = useTheme()
    const [ query, setQuery ] = useState("")
    const [ subscriptions, setSubscriptions ] = useState<MobileSubscription[]>([])
    const [ snack , setSnack ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ showManageModal, setShowManageModal ] = useState<MobileSubscription | undefined>()

    const useFilteredSubscriptions = () => {
        if(!query) return subscriptions

        return subscriptions?.filter(s => {
            if(s.email?.toLowerCase().includes(query.toLowerCase())) return true

        })
    }

    useEffect(() => {

        getAllUserSubscriptions(true)
        
    }, [])

    const getAllUserSubscriptions = async (progress: boolean) => {

        if(progress) setLoading(true)
        try
        {   
            const response = await new BillingApi().getMobileSubscriptions()
            setSubscriptions(response || [])
        }
        catch(error)
        {
            console.error(error)
        }

       if(progress) setLoading(false)

    }

    const filtered = useFilteredSubscriptions()
    const activeCount = subscriptions.filter((item) => item.isActive).length

    return (
        <Box sx={styles.container(theme)}>

            <Grid container direction="column" spacing={2}>
                <Grid item xs={12}>
                    <Box sx={styles.hero(theme)}>
                        <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} justifyContent="space-between">
                            <Box>
                                <Typography variant="overline" sx={styles.eyebrow(theme)}>Billing Console</Typography>
                                <Typography variant="h4" sx={styles.title}>Subscriptions</Typography>
                                <Typography variant="body2" sx={styles.copy(theme)}>
                                    Review active members, renewal timing, platform source, and recent billing changes in one view.
                                </Typography>
                            </Box>
                            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                                <Chip icon={<ReceiptLongRoundedIcon />} label={`${subscriptions.length} total`} sx={styles.heroChip(theme)} />
                                <Chip icon={<CheckCircleRoundedIcon />} label={`${activeCount} active`} sx={styles.heroChip(theme)} />
                            </Stack>
                        </Stack>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <SearchBar placeholder="Search subscriptions" setQuery={setQuery} />
                </Grid>

                <Grid item>
                    { loading && <LottieLoading animation={require("../../animations/person-lottie.json")} height={150} width={150} loop text="Getting Subscriptions" containerHeight="80vh" />}
                    { !loading && subscriptions?.length === 0 && <LottieLoading animation={require("../../animations/log-lottie.json")} height={150} width={150} loop={false} text="No user subscriptions" containerHeight="80vh" />}

                </Grid>

                { !loading && subscriptions?.length > 0 && <Grid item>
                    <SubscriptionsList subscriptions={filtered} onEdit={setShowManageModal}/>
                </Grid> }
                
            </Grid>

            { showManageModal && showManageModal?.androidPurchaseToken && <SubscriptionManageModalAndroid onRefresh={() => getAllUserSubscriptions(false)} open subscriptionListItem={showManageModal} onClose={() => setShowManageModal(undefined)} />}
            { showManageModal && showManageModal?.IOSreceipt && <SubscriptionManageModalApple onRefresh={() => getAllUserSubscriptions(false)} open subscriptionListItem={showManageModal} onClose={() => setShowManageModal(undefined)} />}


        </Box>
    )
}

const styles = {
    container: (theme: any) => ({
        minHeight: "100%",
        padding: 12,
        background:
          theme.palette.mode === "dark"
            ? `radial-gradient(circle at top, ${alpha("#123457", 0.24)} 0%, transparent 38%), linear-gradient(180deg, #08111d 0%, #0b1422 100%)`
            : `radial-gradient(circle at top, ${alpha("#60b8ff", 0.14)} 0%, transparent 38%), linear-gradient(180deg, #f4f8fc 0%, #eaf1fb 100%)`,
    }),
    hero: (theme: any) => ({
        p: 1.5,
        borderRadius: "16px",
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.6)}`,
        background:
          theme.palette.mode === "dark"
            ? `linear-gradient(135deg, ${alpha("#10233d", 0.94)} 0%, ${alpha("#0d1827", 0.94)} 55%, ${alpha("#12334a", 0.86)} 100%)`
            : `linear-gradient(135deg, ${alpha("#ffffff", 0.96)} 0%, ${alpha("#eef6ff", 0.94)} 55%, ${alpha("#d8ebff", 0.9)} 100%)`,
    }),
    eyebrow: (theme: any) => ({
        letterSpacing: 1.5,
        color: alpha(theme.palette.text.primary, 0.62),
    }),
    title: {
        fontWeight: 700,
        mb: 0.5,
    },
    copy: (theme: any) => ({
        maxWidth: 720,
        color: alpha(theme.palette.text.primary, 0.7),
    }),
    heroChip: (theme: any) => ({
        borderRadius: "10px",
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.72),
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.45)}`,
        '& .MuiChip-label': {
            fontWeight: 700,
        },
    }),
}
